import React from 'react'

const Videos = () => {
    return (
        <div>Videos</div>
    )
}

export default Videos